export { default as LogoFull } from "./LogoFull";
export { default as LogoMark } from "./LogoMark";

export interface LogoProps {
  height?: number;
  className?: string;
}
